var _defs, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResourceImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    className: "w-50",
    fill: "#fff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n        .cls-white {\n        fill: #fff;\n        stroke-width: 0px;\n        }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-white",
    d: "M100,185c-.6,0-1.3-.2-1.8-.6l-69-53.2c-.7-.6-1.2-1.4-1.2-2.4s.4-1.8,1.2-2.4l18.7-14.4c1.1-.8,2.6-.8,3.7,0l48.5,37.4,48.5-37.4c1.1-.8,2.6-.8,3.7,0l18.7,14.4c.7.6,1.2,1.4,1.2,2.4s-.4,1.8-1.2,2.4l-69,53.2c-.5.4-1.2.6-1.8.6ZM35.9,128.8l64.1,49.4,64.1-49.4-13.8-10.6-48.5,37.4c-1.1.8-2.6.8-3.7,0l-48.5-37.4-13.8,10.6Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-white",
    d: "M100,156.2c-.6,0-1.3-.2-1.8-.6L29.1,102.4c-.7-.6-1.2-1.4-1.2-2.4s.4-1.8,1.2-2.4l18.7-14.4c1.1-.8,2.6-.8,3.7,0l48.5,37.4,48.5-37.4c1.1-.8,2.6-.8,3.7,0l18.7,14.4c.7.6,1.2,1.4,1.2,2.4s-.4,1.8-1.2,2.4l-69,53.2c-.5.4-1.2.6-1.8.6ZM35.9,100l64.1,49.4,64.1-49.4-13.8-10.6-48.5,37.4c-1.1.8-2.6.8-3.7,0l-48.5-37.4-13.8,10.6Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-white",
    d: "M100,127.4c-.6,0-1.3-.2-1.8-.6L29.1,73.5c-.7-.6-1.2-1.4-1.2-2.4s.4-1.8,1.2-2.4L98.2,15.6c1.1-.8,2.6-.8,3.7,0l69,53.2c.7.6,1.2,1.4,1.2,2.4s-.4,1.8-1.2,2.4l-69,53.2c-.5.4-1.2.6-1.8.6ZM35.9,71.2l64.1,49.4,64.1-49.4L100,21.8l-64.1,49.4Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResourceImg);
export default __webpack_public_path__ + "static/media/resource-img.6cd938e6499a031a5f2998effe742c20.svg";
export { ForwardRef as ReactComponent };